'use client';

import { useMemo, useSyncExternalStore } from 'react';

import { LANDING_TWEETS } from '../../constants/landing-constants';
import { TweetEmbed } from '../common/tweet-embed';

const INDIA_TIME_ZONES = new Set(['Asia/Kolkata', 'Asia/Calcutta']);

const subscribeNoop = () => () => {};

const getIsIndiaTimeZone = () =>
	INDIA_TIME_ZONES.has(Intl.DateTimeFormat().resolvedOptions().timeZone);

// Tweets are only shown to visitors in India; the server snapshot is false so nothing flashes for others.
export const SocialProofSection = () => {
	const isIndiaTimeZone = useSyncExternalStore(subscribeNoop, getIsIndiaTimeZone, () => false);
	const tweets = useMemo(() => [...LANDING_TWEETS, ...LANDING_TWEETS], []);

	if (!isIndiaTimeZone) return null;

	return (
		<section className="mb-14 w-full pt-8 md:mb-20 md:pt-12">
			<div className="overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]">
				<ul
					className="flex w-max animate-marquee-left items-stretch gap-4 py-2 [animation-duration:24s] hover:[animation-play-state:paused] motion-reduce:animate-none md:gap-5"
				>
					{tweets.map((tweet, index) => (
						<li
							key={`${tweet.id}-${index}`}
							className="flex shrink-0"
						>
							<TweetEmbed tweet={tweet} />
						</li>
					))}
				</ul>
			</div>
		</section>
	);
};
